"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
exports.theme = {
    shared: 'inline-flex flex-shrink-0 justify-center items-center relative transition border hover:ring',
    types: {
        default: {
            layer: 'bg-button-default-background border-button-default-border hover:ring-button-default-ring rounded-button',
            text: 'font-semibold text-button-default-text',
        },
        header: {
            layer: 'bg-button-header-background border-button-header-border hover:ring-button-header-ring rounded-button',
            text: 'font-semibold text-button-header-text',
        },
        secondary: {
            layer: 'bg-white border border-misc-300 hover:ring-misc-300',
            text: 'text-primary-500',
        },
        alternative: {
            layer: 'bg-button-alternative-background border-button-alternative-border hover:ring-button-alternative-ring rounded-button',
            text: 'font-semibold text-button-alternative-text',
        },
        danger: {
            layer: 'bg-danger-500 border-danger-500 hover:ring-danger-200 rounded-button',
            text: 'font-semibold text-absolute-0',
        },
        outline: {
            layer: 'bg-white border-none',
            text: 'text-primary-500',
        },
        cta: {
            layer: 'bg-button-cta-background border-button-cta-border hover:ring-button-cta-ring rounded-button',
            text: 'font-semibold text-button-cta-text',
        },
    },
    sizes: {
        small: {
            layer: 'rounded-button h-7 w-7',
        },
        default: {
            layer: 'rounded-button h-8 w-8',
        },
        large: {
            layer: 'rounded-button h-9 w-9',
        },
    },
    states: {
        disabled: {
            layer: elements_ui_utils_1.globalColorClasses.disabled,
        },
        focus: {
            layer: elements_ui_utils_1.globalColorClasses.focus,
        },
    },
};
//# sourceMappingURL=theme.js.map